import { useState } from 'react';

import { getFileTransferErrorMessage } from '#/utils/blobResponseError';
import { triggerBlobDownload } from '#/utils/downloadBlob';
import { toast } from '#/utils/toast';

/**
 * 請款單／憑證列印：呼叫 print API，成功後下載 PDF。
 * @param {() => Promise<{ blob: Blob, filename: string }>} printFn
 * @param {(error: unknown, fallback: string) => string} getErrorMessage 模組的 API 錯誤訊息（後端 JSON 錯誤）
 */
function useFmsPrintPdf(printFn, getErrorMessage) {
  const [isPrinting, setIsPrinting] = useState(false);

  async function print() {
    setIsPrinting(true);
    try {
      const { blob, filename } = await printFn();
      triggerBlobDownload(blob, filename);
    } catch (error) {
      toast.error(
        getFileTransferErrorMessage(error)
        || getErrorMessage(error, '列印失敗'),
      );
    } finally {
      setIsPrinting(false);
    }
  }

  return { isPrinting, print };
}

export default useFmsPrintPdf;
